import { CREATE_TAG, DELETE_TAG, GET_TAG, GET_TAGS, UPDATE_TAG } from '@/store/types/tag';

export function getTag(data) {
  return { type: GET_TAG, data };
}

export function getTags(query) {
  return { type: GET_TAGS, query };
}

export function createTag(payload, callback) {
  return { type: CREATE_TAG, payload, callback };
}
export function updateTag(id, payload) {
  return { type: UPDATE_TAG, id, payload };
}

export function deleteTag(id, callback) {
  return { type: DELETE_TAG, id, callback };
}
